import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EstadoFiltrosService {
  private filtrosSubject = new BehaviorSubject<any[]>([]);
  filtros$ = this.filtrosSubject.asObservable();

  setFiltros(filtros: any[]) {
    this.filtrosSubject.next(filtros);
  }

  getFiltros() {
    return this.filtrosSubject.getValue();
  }
}
